var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6A6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.8,51l-25-43.4c-1-1.7-2.7-2.7-4.7-2.7h0c-2,0-3.7,1-4.7,2.7L2.2,51c-1,1.7-1,3.7,0,5.4 c1,1.7,2.7,2.7,4.7,2.7H57c2,0,3.7-1,4.7-2.7C62.7,54.7,62.7,52.7,61.8,51z M58.6,54.6c-0.2,0.3-0.6,0.9-1.5,0.9H7 c-0.9,0-1.4-0.6-1.5-0.9c-0.2-0.3-0.5-1,0-1.7l25-43.4c0.5-0.8,1.2-0.9,1.5-0.9h0c0.3,0,1.1,0.1,1.5,0.9l25,43.4 C59,53.6,58.7,54.3,58.6,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,43.7c-1,0-1.9,0.4-2.5,1c-0.7,0.7-1,1.6-1,2.6c0,1,0.3,1.9,1,2.6c0.7,0.7,1.5,1.1,2.5,1.1 c1,0,1.9-0.4,2.6-1.1c0.7-0.7,1.1-1.6,1.1-2.5c0-1-0.4-1.9-1-2.6C33.9,44,33,43.7,32,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,20.7c-1.2,0-2.1,0.4-2.8,1.3c-0.6,0.8-1,2-1,3.5c0,0.3,0.1,1,0.2,2.2c0.2,1.1,0.4,2.5,0.7,4.3 c0.3,1.5,0.5,3,0.7,4.4c0.2,1.4,0.4,2.8,0.6,4.3c0,0.4,0.2,0.7,0.5,1c0.3,0.3,0.6,0.5,0.9,0.5c0.1,0,0.1,0,0.2,0 c0.3,0,0.6-0.1,0.8-0.3c0.3-0.2,0.5-0.7,0.6-1.3c0.2-1.6,0.4-3,0.6-4.3c0.2-1.3,0.4-2.7,0.7-4.2c0.3-1.8,0.6-3.2,0.7-4.3 c0.2-1.1,0.3-1.8,0.3-2.1c0-1.5-0.3-2.7-1-3.5C34.1,21.1,33.2,20.7,32,20.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/Icon_Error.931e4c7486aa57250ccbbd8e742dda03.svg";
export { ForwardRef as ReactComponent };